import { IApplicationState } from '../../types/redux';

export function selectBuildersLocations(state: IApplicationState) {
  return state.buildersLocations.data;
}
